<template>
  <section class="section-label-banners">
    <section-header :title="section.title" />
    <div
      v-if="showDescription(section)"
      v-dompurify-html="section.description"
      class="section-description"
    />

    <carousel
      ref="slider"
      class="label-carousel"
      :per-page-custom="[
        [320, 1],
        [768, 1]
      ]"
      :scroll-per-page="isMobile"
      :pagination-enabled="false"
      :mouse-drag="isMobile"
      :value="activeStep"
    >
      <slide
        v-for="(banner, index) in section.banners"
        :key="index"
        class="banner"
      >
        <index-label-mobile
          v-if="isMobile"
          :banner="banner"
          :link="section.link"
        />

        <index-label-desktop
          v-else
          :index="index"
          :count="section.banners.length"
          :banner="banner"
          :link="section.link"
          @navigate="navigate"
        />
      </slide>
    </carousel>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import get from 'lodash-es/get'
  import { Carousel, Slide } from 'vue-carousel'

  const SectionHeader = () =>
    import(
      /* webpackChunkName: "index-section-header" */ 'containers/Pages/IndexPage/SectionHeader'
    )

  const IndexLabelDesktop = () =>
    import(
      /* webpackChunkName: "index-label-desktop" */ 'containers/Pages/IndexPage/IndexLabels/Desktop'
    )
  const IndexLabelMobile = () =>
    import(
      /* webpackChunkName: "index-label-mobile" */ 'containers/Pages/IndexPage/IndexLabels/Mobile'
    )

  export default {
    components: {
      SectionHeader,
      Carousel,
      Slide,
      IndexLabelDesktop,
      IndexLabelMobile
    },
    props: {
      section: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        activeStep: 0
      }
    },
    computed: {
      ...mapGetters('device', ['isDesktop', 'isMobile']),
      ...mapState('indexPage/bestBuyBanners', {
        origDestLabels: 'labels'
      }),
      ...mapState('indexPage', {
        countryList: 'countries'
      })
    },
    methods: {
      navigate(index, direction) {
        let step = index + direction

        if (step < 0) {
          step = 0
        }

        this.activeStep = step
      },
      showDescription(section) {
        return get(section, 'description', '') !== ''
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';
  @import '~assets/styles/components/carousel-navigation-common.scss';

  .banner {
    max-width: 295px;
    display: flex;

    @include bp-mf-tablet {
      width: auto;
      display: initial;
    }
  }

  ::v-deep .VueCarousel-inner {
    flex-basis: 295px !important;
    width: 295px;
    height: calc(100% + 22px);
    padding-bottom: 20px;

    @include bp-mf-tablet {
      width: 100% !important;
      flex-basis: 100% !important;
    }
  }

  ::v-deep .VueCarousel-slide {
    max-width: 295px;
    position: relative;

    @include bp-mf-tablet {
      max-width: 100% !important;
    }

    &:last-child {
      .card {
        margin-right: 0;
      }
    }
  }
</style>
